import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

interface ROIMetricCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  tooltipText: string;
}

export function ROIMetricCard({
  icon,
  label,
  value,
  tooltipText
}: ROIMetricCardProps) {
  return (
    <div className="border rounded-lg p-3 text-left bg-white flex-1 min-w-[150px] shadow-sm">
      <div className="flex items-center justify-between">
        <div className="text-blue-500">{icon}</div>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <Info className="h-4 w-4 text-gray-400" />
            </TooltipTrigger>
            <TooltipContent>
              <p>{tooltipText}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div className="text-xl font-bold mt-2">{value}</div>
      <div className="text-sm text-gray-500 mt-1">{label}</div>
    </div>
  );
}
